import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
// import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
// import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { BiCheckbox } from "react-icons/bi";
import { BiCheckboxChecked } from "react-icons/bi";
import { Typography } from '@mui/material';

// const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
// const checkedIcon = <CheckBoxIcon fontSize="small" />;

const icon = <BiCheckbox size={"1em"}/>;
const checkedIcon = <BiCheckboxChecked size={"1em"}/>;

export default function CheckboxSelect(cbprops) {

const onSelectOption = (event, value) => {
    cbprops.setValue(value);
  }

  return (
    <div style={{width: "100%"}}>
    <Autocomplete
      multiple={cbprops.multiple === false ? false : true}
      id={`checkboxSelect${cbprops.id}`}
      options={cbprops.options}
      value={cbprops.value}
      disableCloseOnSelect={cbprops.multiple === false ? false : true}
      onChange={onSelectOption}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option, { selected }) => {
        const { key, ...optionProps } = props;
        return (
          <li {...optionProps} key={key} style={{padding: 0}}>
            <Checkbox
              icon={icon}
              checkedIcon={checkedIcon}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            <Typography variant="body2">{option.label}</Typography>
          </li>
        );
      }}
      style={{ margin: 8, padding: 0 }}
      renderInput={(params) => (
        <TextField {...params} label={cbprops.name} size="small" sx={{fieldset: { borderColor: "#888888" }}} slotProps={{
          inputLabel: {
            sx: {
              fontSize: "0.875rem",
              color: '#555555',
            }
          }
        }} />
      )}
    />
    { cbprops.value && cbprops.value.label === "Other" ? 
    <TextField id={`text-other-${cbprops.id}`} label={"Specify other"} style={{ margin: 8, padding: 0, width: '80%' }} 
        size="small" sx={{fieldset: { borderColor: "#888888" }}} slotProps={{
          inputLabel: {
            sx: {
              fontSize: "0.875rem",
              color: '#555555',
            }
          }
        }} value={cbprops.otherValue} onChange={(e) => cbprops.setOtherValue(e.target.value)} /> 
        : <div/> }
    </div>
  );
}

